import React, { useState } from 'react';
import { useModalStore } from '../../stores/useUIStore'; // 🟢 CORRECCIÓN: La ruta del store es relativa a la carpeta de componentes
import apiClient from '../../api/api';
import toast from 'react-hot-toast';
import DatePicker from 'react-datepicker';

const colorOptions = [
  { name: 'Azul', value: '#3788d8' },
  { name: 'Verde', value: '#28a745' },
  { name: 'Rojo', value: '#dc3545' },
  { name: 'Amarillo', value: '#ffc107' },
  { name: 'Cian', value: '#17a2b8' },
];

const weekDays = [
  { label: 'D', value: 0 }, { label: 'L', value: 1 }, { label: 'M', value: 2 },
  { label: 'X', value: 3 }, { label: 'J', value: 4 }, { label: 'V', value: 5 }, { label: 'S', value: 6 }
];

const CreateAdminEventModal = ({ initialDate, onEventCreated, eventToEdit }) => {
  const closeModal = useModalStore((state) => state.closeModal);
  const [title, setTitle] = useState(eventToEdit?.title || '');
  const [startDate, setStartDate] = useState(eventToEdit ? new Date(eventToEdit.start) : initialDate || new Date());
  const [allDay, setAllDay] = useState(eventToEdit?.allDay ?? true);
  const [startTime, setStartTime] = useState(eventToEdit?.startTime || '09:00');
  const [endTime, setEndTime] = useState(eventToEdit?.endTime || '10:00');
  const [daysOfWeek, setDaysOfWeek] = useState(eventToEdit?.daysOfWeek || []);
  const [color, setColor] = useState(eventToEdit?.color || colorOptions[0].value);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) {
      toast.error('El título del evento es obligatorio.');
      return;
    }

    setIsSubmitting(true);
    try {
      const eventData = {
        title,
        allDay,
        color,
      };

      if (daysOfWeek.length > 0) {
        eventData.daysOfWeek = daysOfWeek;
        if (!allDay) {
          eventData.startTime = startTime;
          eventData.endTime = endTime;
        }
      } else {
        eventData.start = startDate;
        eventData.end = startDate;
      }

      const promise = eventToEdit
        ? apiClient.patch(`/admin/events/${eventToEdit._id}`, eventData)
        : apiClient.post('/admin/events', eventData);

      await promise;
      toast.success(eventToEdit ? 'Evento actualizado.' : 'Evento creado.');
      onEventCreated(); // Llama al callback para refrescar el calendario
      closeModal();
    } catch (error) {
      // 🟢 SOLUCIÓN: Mostramos el mensaje de error específico del backend.
      toast.error(error.response?.data?.message || 'No se pudo guardar el evento.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-xl w-full max-w-md">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">{eventToEdit ? 'Editar Evento' : 'Crear Nuevo Evento'}</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="title" className="block text-sm font-medium text-gray-700">Título del Evento</label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="mt-1 w-full p-2 border rounded-md"
            required
          />
        </div>
        <div className="flex items-center">
          <input type="checkbox" id="allDay" checked={allDay} onChange={(e) => setAllDay(e.target.checked)} className="h-4 w-4 rounded" />
          <label htmlFor="allDay" className="ml-2 block text-sm text-gray-900">Todo el día</label>
        </div>
        {daysOfWeek.length === 0 && (
          <div>
            <label className="block text-sm font-medium text-gray-700">Fecha</label>
            <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} className="mt-1 w-full p-2 border rounded-md" dateFormat="dd/MM/yyyy" />
          </div>
        )}
        {!allDay && (
          <div className="flex space-x-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Hora Inicio</label>
              <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} className="mt-1 w-full p-2 border rounded-md" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Hora Fin</label>
              <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} className="mt-1 w-full p-2 border rounded-md" />
            </div>
          </div>
        )}
        <div>
          <label className="block text-sm font-medium text-gray-700">Repetir en</label>
          <div className="flex space-x-1 mt-2">
            {weekDays.map(day => (
              <button
                key={day.value}
                type="button"
                onClick={() => {
                  const newDays = daysOfWeek.includes(day.value)
                    ? daysOfWeek.filter(d => d !== day.value)
                    : [...daysOfWeek, day.value];
                  setDaysOfWeek(newDays);
                }}
                className={`w-8 h-8 rounded-full text-xs font-semibold ${daysOfWeek.includes(day.value) ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`}
              >
                {day.label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Color</label>
          <div className="flex space-x-2 mt-2">
            {colorOptions.map((opt) => (
              <button
                key={opt.value}
                type="button"
                onClick={() => setColor(opt.value)}
                className={`w-8 h-8 rounded-full transition-transform transform ${color === opt.value ? 'scale-110 ring-2 ring-offset-2 ring-blue-500' : ''}`}
                style={{ backgroundColor: opt.value }}
                title={opt.name}
              ></button>
            ))}
          </div>
        </div>
        <div className="flex justify-end space-x-3 pt-4">
          <button type="button" onClick={closeModal} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancelar</button>
          <button type="submit" disabled={isSubmitting} className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-blue-400">
            {isSubmitting ? 'Guardando...' : (eventToEdit ? 'Guardar Cambios' : 'Crear Evento')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateAdminEventModal;